import { Action } from '@ngrx/store';
import { Customer } from './../../models/customer';
import { Company } from './../../models/company';
import { Jobsite } from './../../models/jobsite';

export enum PaymentLayoutActionTypes {
    CLEAR_CUSTOMERS = '[PAYMENTS LAYOUT] Clear Customers',
    LOAD_CUSTOMERS = '[PAYMENTS LAYOUT] Load Customers',
    LOAD_CUSTOMERS_SUCCESS = '[PAYMENTS LAYOUT] Load Customers Success',
    ADD_CUSTOMER = '[PAYMENTS LAYOUT] Add Customer',
    CLEAR_COMPANIES = '[PAYMENTS LAYOUT] Clear Companies',
    LOAD_COMPANIES = '[PAYMENTS LAYOUT] Load Companies',
    LOAD_COMPANIES_SUCCESS = '[PAYMENTS LAYOUT] Load Companies Success',
    CLEAR_JOBSITES = '[PAYMENTS LAYOUT] Clear Jobsites',
    LOAD_JOBSITES = '[PAYMENTS LAYOUT] Load Jobsites',
    LOAD_JOBSITES_SUCCESS = '[PAYMENTS LAYOUT] Load Jobsites Success',
    EXIT_PAYMENTS_PAGE = '[PAYMENTS LAYOUT] Exit Payments Page',
}

export namespace PaymentLayoutActions {

    export class ClearCustomers implements Action {
        readonly type = PaymentLayoutActionTypes.CLEAR_CUSTOMERS;
    }

    export class LoadCustomers implements Action {
        readonly type = PaymentLayoutActionTypes.LOAD_CUSTOMERS;
    }

    export class LoadCustomersSuccess implements Action {
        readonly type = PaymentLayoutActionTypes.LOAD_CUSTOMERS_SUCCESS;

        constructor(public payload: Customer[]) { }
    }

    export class AddCustomer implements Action {
        readonly type = PaymentLayoutActionTypes.ADD_CUSTOMER;

        constructor(public payload: Customer) { }
    }

    export class ClearCompanies implements Action {
        readonly type = PaymentLayoutActionTypes.CLEAR_COMPANIES;
    }

    export class LoadCompanies implements Action {
        readonly type = PaymentLayoutActionTypes.LOAD_COMPANIES;
    }

    export class LoadCompaniesSuccess implements Action {
        readonly type = PaymentLayoutActionTypes.LOAD_COMPANIES_SUCCESS;

        constructor(public payload: Company[]) { }
    }

    export class ClearJobsites implements Action {
        readonly type = PaymentLayoutActionTypes.CLEAR_JOBSITES;
    }

    export class LoadJobsites implements Action {
        readonly type = PaymentLayoutActionTypes.LOAD_JOBSITES;
    }

    export class LoadJobsitesSuccess implements Action {
        readonly type = PaymentLayoutActionTypes.LOAD_JOBSITES_SUCCESS;

        constructor(public payload: Jobsite[]) { }
    }

    export class ExitPaymentsPage implements Action {
        readonly type = PaymentLayoutActionTypes.EXIT_PAYMENTS_PAGE;
    }
}

export type PaymentLayoutActions =
    | PaymentLayoutActions.ClearCustomers
    | PaymentLayoutActions.LoadCustomers
    | PaymentLayoutActions.LoadCustomersSuccess
    | PaymentLayoutActions.AddCustomer
    | PaymentLayoutActions.ClearCompanies
    | PaymentLayoutActions.LoadCompanies
    | PaymentLayoutActions.LoadCompaniesSuccess
    | PaymentLayoutActions.ClearJobsites
    | PaymentLayoutActions.LoadJobsites
    | PaymentLayoutActions.LoadJobsitesSuccess
    | PaymentLayoutActions.ExitPaymentsPage;
